import { useState } from 'react';
import { useDispatch } from 'react-redux';
import classes from './StepsAsymmetry.module.scss';
import {PeriodToggle} from '../ClickingOverview/components/PeriodToggle/PeriodToggle';
import {Legend} from '../ClickingOverview/components/Legend/Legend';

const legendData: any[] = [
  [
    {
      label: 'Right leg clicks',
      color: '#7897FF',
    },
    {
      label: 'Left leg clicks',
      color: '#032596',
    },
  ],
  [
    {
      label: 'Planned Right leg clicks',
      color: '#F2F5FF',
      border: '#7897FF',
    },
    {
      label: 'Planned Left leg clicks',
      color: '#E5EBFE',
      border: '#9BB2FD',
    },
  ],
];

export const StepsAsymmetry = ({
  patientId,
}: {
  patientId: string;
}) => {
  const dispatch = useDispatch();
  const [dates, setDates] = useState<null | {start: Date, end: Date}>(null);

  // useEffect(() => {
  //   dispatch({
  //     type: GET_DEFAULT_MEDICATIONS_REQUEST,
  //   });
  // }, [dispatch]);

  return (
    <div className={classes.clickingOverviewContainer}>
      <div className={classes.chartHeader}>
        <PeriodToggle setDates={setDates} />
        
        <Legend legendData={legendData} />
      </div>
    </div>
  );
};
